import React from 'react';

// Arabic version of the terms of service content (the English page remains the reference text)
const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-bold text-slate-900 mb-4">{title}</h2>
    {children}
  </section>
);

const P = ({ children }) => <p className="text-slate-600 leading-relaxed mb-4">{children}</p>;
const List = ({ children }) => <ul className="list-disc ps-6 text-slate-600 space-y-2 mb-4">{children}</ul>;

const TermsOfServiceAr = () => (
  <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12">
    <h1 className="text-3xl font-extrabold text-slate-900 mb-2">شروط الخدمة</h1>
    <p className="text-slate-500 mb-2">آخر تحديث: 27 يناير 2026</p>
    <p className="text-xs text-slate-400 mb-8">
      هذه ترجمة عربية للتسهيل. في حال وجود أي اختلاف بين النسختين، تُعتمد النسخة الإنجليزية.
    </p>

    <div className="prose prose-slate max-w-none">
      <Section title="1. الموافقة على الشروط">
        <P>
          باستخدامك لـ ArabCap أو الوصول إليه، فإنك توافق على الالتزام بشروط الخدمة هذه. إذا كنت لا توافق عليها،
          فلا ينبغي لك استخدام الخدمة.
        </P>
      </Section>

      <Section title="2. وصف الخدمة">
        <P>
          يقدّم ArabCap خدمة إنشاء الترجمة بالذكاء الاصطناعي للهجات العربية، بما فيها الدارجة والمصرية والخليجية
          والعربية الفصحى المعاصرة. وتشمل الخدمات:
        </P>
        <List>
          <li>التعرّف التلقائي على الكلام وتفريغه نصيًا</li>
          <li>أدوات تعديل الترجمة وضبط توقيتها</li>
          <li>خيارات التصدير بصيغ مثل SRT وVTT</li>
        </List>
      </Section>

      <Section title="3. حسابات المستخدمين">
        <P>لاستخدام ArabCap، يجب عليك إنشاء حساب. وتكون مسؤولًا عن:</P>
        <List>
          <li>تقديم معلومات تسجيل دقيقة وكاملة</li>
          <li>الحفاظ على سرية بيانات تسجيل الدخول</li>
          <li>جميع الأنشطة التي تتم من خلال حسابك</li>
          <li>إبلاغنا فورًا بأي دخول غير مصرح به</li>
        </List>
      </Section>

      <Section title="4. الاستخدام المقبول">
        <P>توافق على عدم القيام بما يلي:</P>
        <List>
          <li>رفع محتوى لا تملك حق استخدامه</li>
          <li>مخالفة أي قوانين أو أنظمة</li>
          <li>التعدي على حقوق الملكية الفكرية</li>
          <li>رفع محتوى ضار أو غير قانوني أو مسيء</li>
          <li>محاولة الوصول غير المصرح به إلى أنظمتنا</li>
          <li>التشويش على الخدمة</li>
          <li>استخدام أنظمة آلية دون إذن</li>
        </List>
      </Section>

      <Section title="5. ملكية المحتوى">
        <P>
          <strong>محتواك:</strong> تحتفظ بملكية كل المحتوى الذي ترفعه. وباستخدامك لـ ArabCap، تمنحنا ترخيصًا محدودًا
          لمعالجة محتواك فقط بغرض تقديم خدمة إنشاء الترجمة.
        </P>
        <P>
          <strong>خدمتنا:</strong> يظل ArabCap ومحتواه الأصلي وميزاته وتقنياته ملكًا لـ ArabCap، وهي محمية بموجب
          قوانين الملكية الفكرية.
        </P>
      </Section>

      <Section title="6. الاشتراكات والمدفوعات">
        <P>تتطلب بعض ميزات ArabCap اشتراكًا مدفوعًا. وبالاشتراك، فإنك توافق على:</P>
        <List>
          <li>دفع الرسوم المطبقة على الباقة التي تختارها</li>
          <li>تقديم معلومات فوترة دقيقة</li>
          <li>التجديد التلقائي للاشتراك ما لم يتم إلغاؤه</li>
        </List>
        <P>قد يتم استرداد المبالغ وفقًا لتقديرنا. تواصل مع الدعم لطلبات الاسترداد.</P>
      </Section>

      <Section title="7. الباقة المجانية والتجربة المجانية">
        <P>يوفر ArabCap باقة مجانية بميزات واستخدام محدودين.</P>
        <P>
          التجربة المجانية محدودة بشكل صارم بتجربة واحدة لكل شخص. ويُعد إنشاء حسابات متعددة، أو استخدام معلومات
          غير صحيحة، أو محاولة تجاوز حدود الاستخدام للحصول على تجارب مجانية إضافية احتيالًا، وهو ممنوع منعًا باتًا.
        </P>
        <P>
          إذا رصدنا نشاطًا احتياليًا متعلقًا بالتجربة المجانية، نحتفظ بحق تعليق جميع الحسابات المرتبطة أو إغلاقها
          نهائيًا فورًا ودون إشعار مسبق.
        </P>
        <P>قد نعدّل الباقة المجانية أو نوقفها مع إشعار مسبق معقول.</P>
      </Section>

      <Section title="8. توفر الخدمة">
        <P>
          نسعى لتقديم خدمة موثوقة، لكننا لا نضمن توفرها دون انقطاع. قد نجري صيانة أو تحديثات تؤثر مؤقتًا على
          الوصول إلى الخدمة، ولا نتحمل المسؤولية عن أي توقف أو انقطاع في الخدمة.
        </P>
      </Section>

      <Section title="9. دقة النتائج">
        <P>
          قد تحتوي الترجمة المنشأة بالذكاء الاصطناعي على أخطاء. أنت مسؤول عن مراجعة كل المحتوى المنشأ وتعديله
          قبل استخدامه، ولا يتحمل ArabCap المسؤولية عن أي أخطاء.
        </P>
      </Section>

      <Section title="10. حدود المسؤولية">
        <P>
          إلى أقصى حد يسمح به القانون، لا يتحمل ArabCap المسؤولية عن أي أضرار غير مباشرة أو عرضية أو تبعية أو
          عقابية، بما في ذلك خسارة الأرباح أو الإيرادات أو البيانات أو السمعة.
        </P>
      </Section>

      <Section title="11. إنهاء الحساب">
        <P>
          يجوز لنا تعليق الحسابات أو إغلاقها في حال مخالفة هذه الشروط. ويمكنك إغلاق حسابك في أي وقت. وعند
          الإنهاء، يتوقف حقك في استخدام الخدمة فورًا.
        </P>
      </Section>

      <Section title="12. التعديلات على الشروط">
        <P>
          نحتفظ بحق تعديل هذه الشروط في أي وقت. ويُعد استمرارك في استخدام الخدمة بعد التحديثات قبولًا للشروط
          المعدّلة.
        </P>
      </Section>

      <Section title="13. القانون الواجب التطبيق">
        <P>تخضع هذه الشروط وتُفسَّر وفقًا للقوانين المعمول بها، دون مراعاة لمبادئ تنازع القوانين.</P>
      </Section>

      <Section title="14. تواصل معنا">
        <P>إذا كانت لديك أي أسئلة حول شروط الخدمة هذه، يُرجى التواصل معنا على:</P>
        <p className="text-slate-600 leading-relaxed">
          <strong>البريد الإلكتروني:</strong> <span dir="ltr">legal@arabcap.co</span>
        </p>
      </Section>
    </div>
  </div>
);

export default TermsOfServiceAr;
